import { createFileRoute, useNavigate } from '@tanstack/react-router';
import useGetProfile from '@/hooks/users/use-get-profile.hook';

import { paths } from 'src/routes/paths';

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';

import { Iconify } from 'src/components/iconify';
import OrdersCard from 'src/components/shopify/OrdersCard';
import ProductsCard from 'src/components/shopify/ProductsCard';
import CustomersCard from 'src/components/shopify/CustomersCard';
import BrandProfileCard from 'src/components/settings/BrandProfileCard';

export const Route = createFileRoute('/_authed/dashboard/o/$orgId/settings/client/brand/$clientId/')({
  component: ClientBrandDetail,
});

function ClientBrandDetail() {
  const navigate = useNavigate();
  const { orgId, clientId } = Route.useParams();
  const { data: profile, isLoading, error, refetch } = useGetProfile();

  return (
    <>
      <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 2 }}>
        <Button
          size="small"
          startIcon={<Iconify icon="eva:arrow-back-fill" width={16} />}
          onClick={() => navigate({ to: paths.dashboard.orgSettings(orgId).client.brandProfiles })}
          sx={{ textTransform: 'none' }}
        >
          All Clients
        </Button>
        <Stack direction="row" spacing={1}>
          <Button
            size="small"
            variant="outlined"
            startIcon={<Iconify icon="solar:notebook-bold" width={16} />}
            onClick={() => navigate({ to: paths.dashboard.orgSettings(orgId).client.clientKnowledge(clientId) })}
            sx={{ textTransform: 'none' }}
          >
            Brand Knowledge
          </Button>
          <Button
            size="small"
            variant="outlined"
            startIcon={<Iconify icon="solar:bag-4-bold" width={16} />}
            onClick={() => navigate({ to: paths.dashboard.orgSettings(orgId).client.clientProducts(clientId) })}
            sx={{ textTransform: 'none' }}
          >
            Products & Plans
          </Button>
          <Button
            size="small"
            variant="outlined"
            startIcon={<Iconify icon="solar:download-square-bold" width={16} />}
            onClick={() => navigate({ to: paths.dashboard.orgSettings(orgId).client.clientPageImports(clientId) })}
            sx={{ textTransform: 'none' }}
          >
            Import Page
          </Button>
        </Stack>
      </Stack>

      {error ? (
        <Alert
          severity="error"
          sx={{ mb: 3 }}
          action={
            <Button size="small" color="inherit" onClick={() => refetch()}>
              Retry
            </Button>
          }
        >
          {error.message}
        </Alert>
      ) : null}

      {isLoading && !profile ? (
        <Box sx={{ py: 10, display: 'flex', justifyContent: 'center' }}>
          <CircularProgress />
        </Box>
      ) : (
        <Grid container spacing={3}>
          <Grid size={12}>
            <BrandProfileCard />
          </Grid>
        </Grid>
      )}

      {profile?.data?.integrations?.shopify ? (
        <>
          <Typography variant="h5" sx={{ mt: 6, mb: 3 }}>
            Shopify Store Data
          </Typography>
          <Grid container spacing={3}>
            <Grid size={{ xs: 12, md: 6 }}>
              <ProductsCard />
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <OrdersCard />
            </Grid>
            <Grid size={12}>
              <CustomersCard />
            </Grid>
          </Grid>
        </>
      ) : null}
    </>
  );
}
